import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './MenuPoster.css';

const ALL_SECTIONS = [
  { id:'dosa', title:'Dosa · Idly · Uttapam', emoji:'🫓', items:[
    'Dosa', 'Ghee Dosa', 'Onion Dosa', 'Podi Dosa', 'Karampodi Dosa',
    'Masala Dosa', 'Ghee Masala Dosa', 'Pesarattu', 'Masala Pesarattu',
    'Ragi Dosa', 'Egg Dosa', 'Chicken Dosa',
    'Uthappam', 'Onion Uthappam',
    'Idly (3 pcs)', 'Ghee Idly', 'Podi Idly', 'Sambar Idly',
  ]},
  { id:'street', title:'Street Bites', emoji:'🥙', items:[
    'Mysore Bonda', 'Punugulu', 'Chitti Punugulu',
    'Mirchi Bajji', 'Stuffed Mirchi Bajji', 'Cut Mirchi',
    'Onion Pakora', 'Samosa', 'Mini Samosa',
    'Garelu', 'Sambar Vada', 'Vada',
  ]},
  { id:'appetizers', title:'Appetizers', emoji:'🍢', items:[
    'Chilli Paneer', 'Chilli Gobi', 'Gobi 65', 'Paneer 65',
    'Gobi Manchuria', 'Veg Manchuria', 'Paneer Manchuria',
    'Gobi 555', 'Paneer 555',
    'Chilli Chicken', 'Chicken 65', 'Chicken 555',
    'Chilli Shrimp', 'Chicken Manchuria', 'Shrimp Manchuria', 'Shrimp 555',
    'Karvepaku Chicken', 'Karampodi Chicken',
  ]},
  { id:'indochinese', title:'Indo Chinese', emoji:'🥢', items:[
    'Veg Fried Rice', 'Egg Fried Rice', 'Chicken Fried Rice', 'Shrimp Fried Rice',
    'Veg Noodles', 'Egg Noodles', 'Chicken Noodles',
  ]},
  { id:'biryani', title:'Biryanis & Pulaos', emoji:'🍛', items:[
    'Veg Keema Biryani', 'Paneer Biryani',
    'Egg Biryani', 'Raju Garu Kodi',
    'Munagadu Kodi', 'Vijayawada Boneless',
    'DB Special Boneless', 'Andhra Goat Fry',
    'Telangana Goat Fry', 'Shrimp Biryani',
  ]},
  { id:'curries', title:'Curries', emoji:'🫕', items:[
    'Veg Kurma', 'Potato Bhajji Curry',
    'Paneer Butter Masala', 'Paneer Tikka Masala',
    'Chicken Curry', 'Chicken Tikka Masala',
    'Butter Chicken', 'Lamb Tikka Masala',
    'Boneless Chicken Roast',
  ]},
  { id:'breads', title:'Breads', emoji:'🫓', items:[
    'Butter Naan', 'Garlic Naan', 'Paratha',
    'Poori', 'Pulka', 'Chapathi',
  ]},
  { id:'chaats', title:'Chaats', emoji:'🌮', items:[
    'Pani Puri', 'Bhel Puri', 'Sev Puri',
    'Dahi Puri', 'Samosa Chaat', 'Papdi Chaat',
  ]},
  { id:'beverages', title:'Beverages & Desserts', emoji:'☕', items:[
    'Chai', 'Coffee', 'Boost / Horlicks',
    'Mango Lassi', 'Pista Kulfi', 'Mango Kulfi', 'Gulab Jamun',
  ]},
  { id:'specials', title:'Combos & Specials', emoji:'🎁', isSpecial:true, items:[
    'Bonda Punugu Classic', 'Vada Vibe', 'Dosa + 2 Idly',
    '2 Poori + 1 Idly', '2 Bonda + 2 Idly + Tea',
    '1 Vada + 2 Idly + Tea', 'Bajji Combo + Tea',
    '1 Idly + 1 Poori + 2 Bonda', 'Upma + Pongal',
  ]},
];

const TEMPLATES = [
  { id:'street', name:'Street Market', desc:'Fiery orange — bold & rustic',
    bg:'#140800', headerBg:'linear-gradient(160deg,#3d1400,#1a0800)',
    accent:'#ff6b1a', accentLight:'#ffaa70', text:'#fff8f0',
    muted:'rgba(255,248,240,0.5)', sectionBg:'rgba(255,107,26,0.1)',
    footerBg:'#0d0500', divider:'◈─────◈─────◈', ornament:false,
    swatch:'linear-gradient(135deg,#3d1400,#1a0800)' },
  { id:'royal', name:'Royal Gold', desc:'Classic gold — elegant & regal',
    bg:'#0a0800', headerBg:'linear-gradient(160deg,#1e1800,#0a0800)',
    accent:'#c9a227', accentLight:'#e0c060', text:'#fff8e7',
    muted:'rgba(255,248,231,0.45)', sectionBg:'rgba(201,162,39,0.08)',
    footerBg:'#06050a', divider:'⸻ ✦ ⸻', ornament:true,
    swatch:'linear-gradient(135deg,#1e1800,#0a0800)' },
  { id:'modern', name:'Fresh Green', desc:'Crisp green — clean & modern',
    bg:'#f7fdf4', headerBg:'linear-gradient(160deg,#1b7a2a,#0f5c1c)',
    accent:'#1b7a2a', accentLight:'#2aa83d', text:'#1a2e1a',
    muted:'rgba(26,46,26,0.45)', sectionBg:'rgba(27,122,42,0.07)',
    footerBg:'#1b7a2a', divider:'─────────────────', ornament:false, lightHeader:true,
    swatch:'linear-gradient(135deg,#1b7a2a,#0f5c1c)' },
  { id:'spice', name:'Spice Route', desc:'Deep purple — exotic & vibrant',
    bg:'#1a0a1a', headerBg:'linear-gradient(160deg,#3d0a3d,#1a0a1a)',
    accent:'#d946ef', accentLight:'#f0abfc', text:'#fdf0ff',
    muted:'rgba(253,240,255,0.45)', sectionBg:'rgba(217,70,239,0.08)',
    footerBg:'#0d050d', divider:'✦───✦───✦', ornament:false,
    swatch:'linear-gradient(135deg,#3d0a3d,#1a0a1a)' },
];

/* Distribute sections into N columns, balanced by item count.
   If we have fewer sections than columns, reduce column count. */
function packColumns(sections, n) {
  const count = Math.min(n, sections.length);
  const cols = Array.from({ length: count }, () => []);
  const heights = Array(count).fill(0);
  // Sort descending so biggest sections anchor their columns first
  const sorted = [...sections].sort((a, b) => b.items.length - a.items.length);
  for (const sec of sorted) {
    const i = heights.indexOf(Math.min(...heights));
    cols[i].push(sec);
    heights[i] += sec.items.length + 4;
  }
  return cols;
}

function Poster({ tplId, sections, colCount }) {
  const T = TEMPLATES.find(x => x.id === tplId) || TEMPLATES[0];
  const cols = packColumns(sections, colCount);
  const hdrMuted = T.lightHeader ? 'rgba(255,255,255,0.85)' : T.muted;

  return (
    <div id="mp-poster" style={{
      width:'100%', minHeight:1100,
      background:T.bg, color:T.text,
      fontFamily:"Georgia,'Times New Roman',serif",
      border:`6px solid ${T.accent}`,
      boxSizing:'border-box', display:'flex', flexDirection:'column',
      position:'relative', overflow:'hidden',
    }}>
      {/* double inner frame */}
      <div style={{ position:'absolute', inset:9,  border:`1px solid ${T.accent}40`, pointerEvents:'none', zIndex:1 }} />
      <div style={{ position:'absolute', inset:14, border:`1px solid ${T.accent}18`, pointerEvents:'none', zIndex:1 }} />

      {/* ── HEADER ── */}
      <div style={{
        background:T.headerBg, flexShrink:0,
        padding:'24px 36px 18px', textAlign:'center',
        borderBottom:`3px solid ${T.accent}`,
        position:'relative', zIndex:2,
      }}>
        {T.ornament && (
          <div style={{ color:T.accent, fontSize:'0.9rem', letterSpacing:6, marginBottom:6, opacity:0.7 }}>
            &#10087; &#10022; &#10087; &#10022; &#10087;
          </div>
        )}
        {/* Brand row with side rules */}
        <div style={{ display:'flex', alignItems:'center', gap:14, marginBottom:8 }}>
          <div style={{ flex:1, height:1, background:`linear-gradient(90deg,transparent,${T.accent}80)` }} />
          <span style={{ fontSize:'2.6rem', lineHeight:1 }}>🍛</span>
          <div>
            <div style={{ fontSize:'3rem', fontWeight:900, color:T.accent, letterSpacing:3,
              lineHeight:1, textShadow:`0 2px 24px ${T.accent}60` }}>
              Desi Bites
            </div>
            <div style={{ fontSize:'0.62rem', letterSpacing:5, textTransform:'uppercase',
              color:hdrMuted, marginTop:4 }}>
              Authentic South Indian Street Food
            </div>
          </div>
          <span style={{ fontSize:'2.6rem', lineHeight:1 }}>🍛</span>
          <div style={{ flex:1, height:1, background:`linear-gradient(90deg,${T.accent}80,transparent)` }} />
        </div>

        {/* Ornamental divider */}
        <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:10, margin:'4px 0 10px' }}>
          <div style={{ height:1, width:80, background:T.accent, opacity:0.35 }} />
          <span style={{ color:T.accent, opacity:0.65, fontSize:'0.75rem', letterSpacing:4 }}>✦  ✦  ✦</span>
          <div style={{ height:1, width:80, background:T.accent, opacity:0.35 }} />
        </div>

        {/* Contact row */}
        <div style={{ display:'flex', justifyContent:'center', alignItems:'center',
          gap:0, fontSize:'0.64rem', color:hdrMuted, flexWrap:'wrap' }}>
          <span style={{ padding:'0 12px' }}>📍 226 N Main St, Centerton AR 72719</span>
          <span style={{ opacity:0.3 }}>|</span>
          <span style={{ padding:'0 12px' }}>📞 (479) 412-9916</span>
          <span style={{ opacity:0.3 }}>|</span>
          <span style={{ padding:'0 12px' }}>🌐 desibitesnwa.com</span>
        </div>
      </div>

      {/* ── BODY — newspaper columns ── */}
      <div style={{
        flex:1, display:'flex', gap:0, position:'relative', zIndex:2, minHeight:0,
      }}>
        {cols.map((colSecs, ci) => (
          <div key={ci} style={{
            flex:1, display:'flex', flexDirection:'column',
            borderRight: ci < cols.length - 1 ? `1px solid ${T.accent}25` : 'none',
          }}>
            {colSecs.map((sec, si) => {
              const isLast = si === colSecs.length - 1;
              return (
                <div key={sec.id} style={{
                  flex: sec.items.length + 4,
                  display:'flex', flexDirection:'column',
                  borderBottom: !isLast ? `1px solid ${T.accent}22` : 'none',
                }}>
                  {/* Section banner */}
                  <div style={{
                    display:'flex', alignItems:'center', gap:8, flexShrink:0,
                    padding:'7px 14px 6px',
                    background:`linear-gradient(90deg,${T.accent}22,${T.accent}08)`,
                    borderBottom:`2px solid ${T.accent}55`,
                    borderLeft:`4px solid ${T.accent}`,
                  }}>
                    <span style={{ fontSize:'1.1rem' }}>{sec.emoji}</span>
                    <span style={{ fontSize:'0.7rem', fontWeight:800, letterSpacing:2.5,
                      textTransform:'uppercase', color:T.accentLight, flex:1 }}>
                      {sec.title}
                    </span>
                    <span style={{ fontSize:'0.58rem', color:T.accent, opacity:0.55, fontStyle:'italic' }}>
                      {sec.items.length} items
                    </span>
                  </div>
                  {/* Items — spread evenly to fill height */}
                  <div style={{
                    flex:1, padding:'4px 14px 6px',
                    display:'flex', flexDirection:'column',
                    justifyContent:'space-evenly',
                  }}>
                    {sec.items.map((name, ii) => (
                      <div key={ii} style={{
                        display:'flex', alignItems:'center', gap:7,
                        fontSize:'0.72rem', lineHeight:1.35, color:T.text,
                        borderBottom: ii < sec.items.length - 1
                          ? `1px solid ${T.accent}10` : 'none',
                        paddingBottom:2,
                      }}>
                        <span style={{ color:T.accent, fontSize:'0.42rem', flexShrink:0, opacity:0.8 }}>◆</span>
                        {name}
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>

      {/* ── FOOTER ── */}
      <div style={{
        flexShrink:0, background:T.footerBg,
        borderTop:`2px solid ${T.accent}55`,
        padding:'8px 24px', textAlign:'center',
        position:'relative', zIndex:2,
      }}>
        <div style={{ height:1, background:`linear-gradient(90deg,transparent,${T.accent}60,transparent)`, marginBottom:7 }} />
        <div style={{ fontStyle:'italic', fontSize:'0.68rem', color:T.muted, letterSpacing:1.5 }}>
          "Taste of India, Heart of America"
        </div>
      </div>
    </div>
  );
}

export default function MenuPoster() {
  const [tplId,        setTplId]        = useState('street');
  const [showSpecials, setShowSpecials] = useState(false);
  const [colCount,     setColCount]     = useState(3);
  const [showAll,      setShowAll]      = useState(true);
  const [selected,     setSelected]     = useState(
    new Set(ALL_SECTIONS.filter(s => !s.isSpecial).map(s => s.id))
  );

  const toggleSec = id => setSelected(prev => {
    const n = new Set(prev);
    n.has(id) ? n.delete(id) : n.add(id);
    return n;
  });

  const visibleSections = ALL_SECTIONS.filter(s => {
    if (s.isSpecial) return showSpecials;
    return showAll ? true : selected.has(s.id);
  });

  const handlePrint = () => {
    const el = document.getElementById('mp-poster');
    if (!el) return;
    const w = window.open('', '_blank', 'width=1000,height=1300');
    w.document.write(
      '<!DOCTYPE html><html><head><title>Desi Bites Menu Poster</title>' +
      '<style>@page{size:A2 portrait;margin:0}*{box-sizing:border-box}' +
      'body{margin:0;-webkit-print-color-adjust:exact;print-color-adjust:exact;font-family:Georgia,serif}</style>' +
      '</head><body>' + el.outerHTML + '</body></html>'
    );
    w.document.close();
    w.focus();
    setTimeout(() => w.print(), 600);
  };

  return (
    <div className="mp-page">
      <div className="mp-topbar">
        <div className="mp-topbar__left">
          <Link to="/menu" className="mp-back-btn">&#8592; Menu</Link>
          <div>
            <h1 className="mp-topbar__title">🖨️ Menu Poster Builder</h1>
            <p className="mp-topbar__sub">Design · preview · print for your food truck</p>
          </div>
        </div>
        <button className="mp-print-btn" onClick={handlePrint}>🖨️ Print / Save PDF</button>
      </div>

      <div className="mp-layout">
        <aside className="mp-controls">

          {/* Template picker */}
          <div className="mp-ctrl-group">
            <div className="mp-ctrl-heading">Template</div>
            {TEMPLATES.map(tmpl => (
              <button key={tmpl.id}
                className={`mp-tpl-row ${tplId === tmpl.id ? 'mp-tpl-row--on' : ''}`}
                onClick={() => setTplId(tmpl.id)}>
                <span className="mp-tpl-row__dot"
                  style={{ background:tmpl.swatch, border:`2px solid ${tmpl.accent}` }} />
                <div style={{ flex:1, textAlign:'left' }}>
                  <div className="mp-tpl-row__name">{tmpl.name}</div>
                  <div className="mp-tpl-row__desc">{tmpl.desc}</div>
                </div>
                {tplId === tmpl.id && <span className="mp-tpl-row__tick">✓</span>}
              </button>
            ))}
          </div>

          {/* Column count */}
          <div className="mp-ctrl-group">
            <div className="mp-ctrl-heading">Section Columns</div>
            <div className="mp-col-btns">
              {[2, 3].map(n => (
                <button key={n}
                  className={`mp-col-btn ${colCount === n ? 'mp-col-btn--on' : ''}`}
                  onClick={() => setColCount(n)}>
                  {n === 2 ? '⎟⎟ 2 Col' : '⎟⎟⎟ 3 Col'}
                </button>
              ))}
            </div>
          </div>

          {/* Specials toggle */}
          <div className="mp-ctrl-group">
            <div className="mp-ctrl-heading">Specials</div>
            <label className="mp-toggle-row">
              <input type="checkbox" checked={showSpecials} onChange={e => setShowSpecials(e.target.checked)} />
              <span className="mp-toggle-box" />
              <span>Include Combos &amp; Specials</span>
            </label>
          </div>

          {/* Section picker */}
          <div className="mp-ctrl-group">
            <div className="mp-ctrl-heading">Sections</div>
            <label className="mp-toggle-row" style={{ marginBottom:8 }}>
              <input type="checkbox" checked={showAll} onChange={e => setShowAll(e.target.checked)} />
              <span className="mp-toggle-box" />
              <span>All sections</span>
            </label>
            {!showAll && (
              <div className="mp-sec-checks">
                {ALL_SECTIONS.filter(s => !s.isSpecial).map(s => (
                  <label key={s.id} className="mp-sec-check">
                    <input type="checkbox" checked={selected.has(s.id)} onChange={() => toggleSec(s.id)} />
                    <span className="mp-sec-check__box" />
                    <span>{s.emoji} {s.title}</span>
                  </label>
                ))}
              </div>
            )}
          </div>

          <div className="mp-ctrl-group mp-ctrl-group--tip">
            <div className="mp-ctrl-heading">Print tips</div>
            <ul className="mp-tips">
              <li>Paper: <strong>A2</strong> or <strong>A3</strong></li>
              <li>Enable <strong>Background graphics</strong></li>
              <li>Margins: <strong>None</strong></li>
              <li>Laminate for outdoor use 🌧️</li>
            </ul>
          </div>

          <button className="mp-print-btn mp-print-btn--wide" onClick={handlePrint}>
            🖨️ Print / Save PDF
          </button>
        </aside>

        {/* Poster preview */}
        <div className="mp-canvas">
          <div className="mp-canvas__tag">
            Live preview — <em>{visibleSections.length} sections · {colCount}-column · no prices</em>
          </div>
          <div className="mp-canvas__scroll">
            <div style={{ width:'100%', maxWidth:880 }}>
              <Poster tplId={tplId} sections={visibleSections} colCount={colCount} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
